import { CancelSurgicalOrder } from 'domain/usecases/surgical-order-cancellation/cancel-surgical-order'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteCancelSurgicalOrder implements CancelSurgicalOrder {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  cancel(
    params: CancelSurgicalOrder.Params
  ): Promise<CancelSurgicalOrder.Model> {
    return this.surgicalOrderRepository.cancelSurgicalOrder(params)
  }
}
